<script>
export default {
  name: "MessageRender",
  props: {
    messages: {
      type: Array,
      required: true,
    },
  },
  emits: ['preview-image'],
  setup(props, { emit }) {
    const parsedMessageBody = (body) => (body.replace(/\\"(?=\?)/g, '"'))
    const getPositionMessage = (message) => {
      return (message.is_sender ? 'end' : 'start');
    };
    const handleImageClick = (message, index) => {
      emit('preview-image', message, index);
    };
    return { parsedMessageBody, getPositionMessage, handleImageClick }
  }
}
</script>
<template>
  <template v-for="(messageGroup, index) in messages" :key="index">
    <div class="conversation__message__container__date d-flex justify-content-center align-items-center">
      <div class="conversation__message__date d-flex justify-content-center p-2 shadow">{{ messageGroup?.date }}</div>
    </div>
    <div class="conversation__message__container d-flex flex-column w-100" :class="getPositionMessage(message)"
        v-for="(message, index) in messageGroup?.messages" :key="index">
      <div class="conversation__message shadow d-flex flex-column w-70"
          :class="{'text-light': message.channel_message_type !== 'default'}"
          :style="{ 'backgroundColor': message.channel_message_color }">
        <!-- Message -->
        <div class="conversation__message__user fw-bold mb-2">
          {{ message.first_name }} {{ message.last_name }}
          <span class="badge badge-pill bg-dark-violet ms-1">{{ message.role }}</span>
        </div>
        <!-- Media -->
        <template v-if="message?.attachments?.length">
          <template v-for="(url, index) in message.attachments" :key="index">
            <img @click="handleImageClick(message, index)" class="media mb-2" width="100" :src="url" alt="img">
          </template>
        </template>
        <div v-if="message?.text !== ''" class="conversation__message__text">{{ parsedMessageBody(message.text) }}</div>
        <div class="conversation__message__time text-end">
          {{ message?.time }}
        </div>
      </div>
    </div>
  </template>
</template>

<style scoped lang="scss">
.conversation__message {
  border-radius: 10px;
  margin: 1rem 1.5rem;
  padding: .5rem;
  white-space: pre-line;
}
.conversation__message__user {
  display: flex;
  align-items: center;
}
.conversation__message__user,
.conversation__message__time {
  font-size: 10px;
}
.conversation__message__text,
.conversation__message__date {
  font-size: 12px;
}
.conversation__message__badge__new__message {
  bottom: 60px;
  padding: 5px;
}
.conversation__message__badge__icon__caretdown {
  &:hover {
    cursor: pointer;
  }
}
.end {
  align-items: end;
}
.start {
  align-items: start;
}
.media:hover {
  cursor: pointer;
}
.info {
  background-color: #138496!important;
  color: white!important;
}
.warning {
  background-color: #DD7230 !important;
  color: white !important;
}
.alert {
  background-color: rgb(233, 123, 134) !important;
  color: white !important;
}
</style>
